import React from "react"

import Icons from "./icons"
import text from "../../data/text.json"
import { Wrapper, Li, StyledLink, Ul } from "./styled"

const Nav = () => (
  <Wrapper>
    <Ul>
      {text.navLinks.map((link, i) => {
        const Icon = Icons[link.label]
        return (
          <Li key={i}>
            <StyledLink to={link.url}>
              <Icon /> {link.label}
            </StyledLink>
          </Li>
        )
      })}
    </Ul>
  </Wrapper>
)

export default Nav
